export const validateDocumentType = (document: string): any => {
  document = (document) ? document.replace(/[^0-9]/g, '') : document;

  return (document)
    ? document.length <= 11
      ? 'cpf'
      : document.length > 11 && document.length <= 14
        ? 'cnpj'
        : 'cpf'
    : 'cnpj';
};

export const validateDocument = (document: string): boolean => {
  return (validateDocumentType(document) === 'cpf')
    ? validateCPF(document)
    : (validateDocumentType(document) === 'cnpj')
      ? validateCNPJ(document)
      : validateCPF(document);
};

const calcDigitPositions = (digits: any, positions: number = 10, sumDigits: number = 0): any => {
  [...Array(digits.length)].fill('').forEach((index, key) => {
    const digit = digits[key];

    sumDigits = sumDigits + (digit * positions);

    positions--;
    positions = (positions < 2) ? 9 : positions;
  });

  sumDigits = sumDigits % 11;
  sumDigits = (sumDigits < 2) ? 0 : 11 - sumDigits;

  return digits + sumDigits;
};

export const validateCPF = (document: string): boolean => {
  document = (document) ? document.replace(/[^0-9]/g, '') : '';

  let digits = document.substr(0, 9);
  let newCPF = calcDigitPositions(calcDigitPositions(digits), 11);

  return (newCPF === document);
};

export const validateCNPJ = (document: string): boolean => {
  document = document.replace(/[^0-9]/g, '');

  let digits = document.substr(0, 12);
  let newCNPJ = calcDigitPositions(calcDigitPositions(digits, 5), 6);

  return (newCNPJ === document);
};